<div mat-dialog-title class="dialogTitle">
    <div fxLayout="row">
      <div fxFlex="100">
        <h4 class="titleConfirmModal">{{data?.title | translate}}</h4>
      </div>
    </div>
  </div>
  
  <div mat-dialog-content>
    <div fxLayout="row">
      <div fxFlex="100">
        <p *ngIf="data?.message" style="font-size: 14px; margin-bottom: 14px;">{{data?.message | translate}}</p>
      </div>
    </div>
    <div fxLayout="row" fxLayoutGap="20px" fxLayoutGap.xs="15px" class="form-actions">
      <button *ngIf="data?.existingData"  mat-flat-button fxFlex="50" color="basic" (click)="closeDialog(false)">{{'CONFIRM_MODAL.NO' | translate}}</button>
      <button *ngIf="data?.existingData" [ngClass]="data?.existingData?'mitad':'entero'" mat-flat-button fxFlex="50" color="primary" (click)="closeDialog(true)">{{'CONFIRM_MODAL.YES' | translate}}</button>
      <button *ngIf="!data?.existingData" [ngClass]="data?.existingData?'mitad':'entero'" mat-flat-button fxFlex="50" color="primary" (click)="closeDialog(true)">{{'CONFIRM_MODAL.ACCEPT' | translate}}</button>
    </div>
  </div>
